export default "/assets/images/filter-home-wrecker-box.55fd8f9643b7632c.png";